(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customers-addresses"]) return;
  try {
    
(function () {
  var root = document.querySelector('[data-addresses]');
  if (!root) return;

  // Confirm + submit delete via _method=delete
  root.querySelectorAll('[data-address-delete]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      var message = form.getAttribute('data-confirm') || 'Eliminare?';
      if (!window.confirm(message)) {
        event.preventDefault();
      }
    });
  });

  // Progressive province sync for country selects
  root.querySelectorAll('[data-country-select]').forEach(function (countrySelect) {
    var provinceWrap = document.getElementById(countrySelect.getAttribute('data-province-wrap'));
    var provinceSelect = document.getElementById(countrySelect.getAttribute('data-province-target'));
    if (!provinceWrap || !provinceSelect) return;

    // Honor the persisted/selected country
    var defaultCountry = countrySelect.getAttribute('data-default');
    if (defaultCountry) {
      countrySelect.value = defaultCountry;
    }

    function sync() {
      var option = countrySelect.options[countrySelect.selectedIndex];
      if (!option) return;
      var provincesRaw = option.getAttribute('data-provinces');
      var provinces = [];
      try { provinces = JSON.parse(provincesRaw || '[]'); } catch (e) { provinces = []; }

      if (!provinces.length) {
        provinceWrap.hidden = true;
        provinceSelect.innerHTML = '';
        return;
      }

      provinceWrap.hidden = false;
      provinceSelect.innerHTML = '';
      provinces.forEach(function (pair) {
        var opt = document.createElement('option');
        opt.value = pair[0];
        opt.textContent = pair[1];
        provinceSelect.appendChild(opt);
      });

      var preselect = provinceSelect.getAttribute('data-default');
      if (preselect) provinceSelect.value = preselect;
    }

    countrySelect.addEventListener('change', sync);
    sync();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var heroes = document.querySelectorAll('[data-hero]');
  if (!heroes.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      heroes.forEach(function (hero) {
        var layer = hero.querySelector('[data-hero-parallax]');
        if (!layer) return;
        var rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) {
          ticking = false;
          return;
        }
        var offset = rect.top * -0.12;
        layer.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.06)';
      });
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var section = document.currentScript.closest('[data-collection]') || document;

  // Auto-submit sort
  var sort = section.querySelector('[data-collection-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Mobile filter drawer toggle
  var filters = section.querySelector('[data-collection-filters]');
  var overlay = section.querySelector('[data-collection-filter-overlay]');
  var toggles = section.querySelectorAll('[data-collection-filter-toggle]');

  function openFilters() {
    if (!filters) return;
    filters.classList.add('is-open');
    if (overlay) overlay.hidden = false;
    var trigger = section.querySelector('.collection__filter-toggle');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    if (!filters) return;
    filters.classList.remove('is-open');
    if (overlay) overlay.hidden = true;
    var trigger = section.querySelector('.collection__filter-toggle');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  Array.prototype.forEach.call(toggles, function (btn) {
    btn.addEventListener('click', function () {
      if (filters && filters.classList.contains('is-open')) {
        closeFilters();
      } else {
        openFilters();
      }
    });
  });

  if (overlay) overlay.addEventListener('click', closeFilters);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && filters && filters.classList.contains('is-open')) {
      closeFilters();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gift-card"]) return;
  try {
    
(function () {
  var root = document.currentScript;
  function init() {
    var copyBtn = document.querySelector('[data-gift-card-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var value = copyBtn.getAttribute('data-copy-value') || '';
        var done = function () {
          var d = copyBtn.querySelector('.giftcard__copy-default');
          var k = copyBtn.querySelector('.giftcard__copy-done');
          if (d && k) {
            d.hidden = true;
            k.hidden = false;
            setTimeout(function () {
              d.hidden = false;
              k.hidden = true;
            }, 2000);
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(done).catch(function () {});
        } else {
          var code = document.querySelector('[data-gift-card-code]');
          if (code && window.getSelection && document.createRange) {
            var range = document.createRange();
            range.selectNodeContents(code);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            try { document.execCommand('copy'); done(); } catch (e) {}
            sel.removeAllRanges();
          }
        }
      });
    }
    var printBtn = document.querySelector('[data-gift-card-print]');
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        window.print();
      });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"]) return;
  try {
    
(function () {
  var trigger = document.querySelector('[data-password-login]');
  if (!trigger) return;
  trigger.addEventListener('click', function () {
    var modal = document.querySelector('.shopify-password-modal') || document.getElementById('LoginModal');
    if (modal && typeof modal.classList !== 'undefined') {
      modal.classList.add('is-active', 'modal--is-active');
      var input = modal.querySelector('input[type="password"]');
      if (input) input.focus();
    } else {
      window.location.hash = 'login';
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
